/** 固定、低基数的异常分类，不接收原始错误文本或业务数据。 */
export type AnalyticsDiagnosticCode =
  | 'overflow'
  | 'expired'
  | 'unknown'
  | 'identity_unresolvable'
  | 'unsupported_runtime'
  | 'rejected'
  | 'superseded'
  | 'invalid_snapshot'
  | 'loader_slow'
  | 'loader_degraded'
  | 'loader_failed';
/** 只保留两个SDK、队列和其他provider的固定分类。 */
export type AnalyticsDiagnosticProvider = 'sensors' | 'snowplow' | 'queue' | 'other';
/** 单文档每类最多一次、所有类最多24次，无法通过重试放大诊断。 */
const DOCUMENT_DIAGNOSTIC_LIMIT = 24;
/** 每个document单独保存有界计数，不创建服务器用户状态。 */
const documentDiagnostics = new WeakMap<Document, Map<string, { count: number }>>();

/** 独立监控旁路：同步累计一批计数，动态加载既有Sentry适配，不等待网络或tracker。 */
export function recordAnalyticsDiagnostic(
  code: AnalyticsDiagnosticCode,
  provider: string,
  count = 1,
): void {
  if (typeof document === 'undefined' || !Number.isFinite(count) || count <= 0) return;
  const target: AnalyticsDiagnosticProvider =
    provider === 'sensors' || provider === 'snowplow' || provider === 'queue' ? provider : 'other';
  let diagnostics = documentDiagnostics.get(document);
  if (!diagnostics) {
    diagnostics = new Map();
    documentDiagnostics.set(document, diagnostics);
  }
  const key = `${code}:${target}`;
  const existing = diagnostics.get(key);
  if (existing) {
    existing.count = Math.min(1_000_000, existing.count + count);
    return;
  }
  if (diagnostics.size >= DOCUMENT_DIAGNOSTIC_LIMIT) return;
  const entry = { count: Math.min(1_000_000, count) };
  diagnostics.set(key, entry);
  // 每类只安排一次导入/交接；重复异常只合并首批计数，SDK失败不会触发无界重试。
  void import('@/services/sentry/reportAnalyticsDiagnostic')
    .then(({ reportAnalyticsDiagnostic }) => {
      reportAnalyticsDiagnostic(code, target, entry.count);
    })
    .catch(() => {
      /* 监控异常不得穿透业务，也不依赖故障中的Snowplow自报。 */
    });
}
